const detectJSON = (str: string) => {
  try {
    return JSON.parse(str);
  } catch (error) {
    return str;
  }
};

export default detectJSON;
